import { useState } from 'react'
import { createPortal } from 'react-dom'
import { useIsomorphicLayoutEffect } from 'react-use'

interface PortalProps {
  root: string | HTMLElement
}

function Portal({ children, root }: React.PropsWithChildren<PortalProps>) {
  const [element, setElement] = useState<HTMLElement>(null)

  useIsomorphicLayoutEffect(() => {
    if (root instanceof HTMLElement) {
      setElement(root)
    } else if (typeof root === 'string') {
      const elementCandidate = document.querySelector(root)

      if (elementCandidate instanceof HTMLElement) {
        setElement(elementCandidate)
      }
    } else {
      setElement(document.body)
    }
  }, [root])

  return !!element && createPortal(children, element)
}

export default Portal
